import SMFormFieldDatepicker from './SMFormFieldDatepicker';

export default SMFormFieldDatepicker;
